import { NgModule } from '@angular/core';

// Other Modules
import { QRCodeModule } from 'angularx-qrcode';
import { ImageCropperModule } from 'ngx-image-cropper';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';

// PrimeNG Material
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SidebarModule } from 'primeng/sidebar';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { TabViewModule } from 'primeng/tabview';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { ChipsModule } from 'primeng/chips';
import { AccordionModule } from 'primeng/accordion';
import { OrderListModule } from 'primeng/orderlist';
import { ChartModule } from 'primeng/chart';
import { SkeletonModule } from 'primeng/skeleton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ColorPickerModule } from 'primeng/colorpicker';
import { GalleriaModule } from 'primeng/galleria';
import { TreeModule } from 'primeng/tree';

// Kendo Material
import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { UploadModule } from '@progress/kendo-angular-upload';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { DateInputsModule } from "@progress/kendo-angular-dateinputs";


const components = [
  QRCodeModule,
  ImageCropperModule,
  AutocompleteLibModule,

  ToastModule,
  DialogModule,
  InputSwitchModule,
  ConfirmDialogModule,
  SidebarModule,
  BreadcrumbModule,
  RadioButtonModule,
  SelectButtonModule,
  TooltipModule,
  CalendarModule,
  CheckboxModule,
  TabViewModule,
  MultiSelectModule,
  DropdownModule,
  ChipsModule,
  AccordionModule,
  OrderListModule,
  ChartModule,
  SkeletonModule,
  ProgressSpinnerModule,
  ColorPickerModule,
  GalleriaModule,
  TreeModule,
  
  GridModule,
  DropDownsModule,
  UploadModule,
  PDFExportModule,
  DateInputsModule
];

@NgModule({
  declarations: [],
  imports: [components],
  exports: [components],
})
export class MaterialModule {}
